"use strict";
var ReactifyF7Vue_1 = require("../src/utils/ReactifyF7Vue");
var framework7_vue_1 = require("../framework7-vue/framework7-vue");
exports.FabSpeedDial = ReactifyF7Vue_1.reactifyF7Vue({
    component: framework7_vue_1.VueFabSpeedDial,
    tag: 'f7-fab-speed-dial'
});

//# sourceMappingURL=FabSpeedDial.js.map



//////////////////
// WEBPACK FOOTER
// ./~/framework7-react/dist/framework7-react/FabSpeedDial.js
// module id = 184
// module chunks = 0